import { createFileRoute } from "@tanstack/react-router";
import { FunctionsList, type FunctionsSearch } from "../../features/functions/functions-list";

const TABS = ["functions", "apps", "calls"] as const;

export const Route = createFileRoute("/_authed/$org/$project/functions/")({
  validateSearch: (s: Record<string, unknown>): FunctionsSearch => ({
    ...(TABS.includes(s.tab as never) ? { tab: s.tab as FunctionsSearch["tab"] } : {}),
    ...(typeof s.q === "string" && s.q ? { q: s.q } : {}),
  }),
  component: FunctionsPage,
});

function FunctionsPage() {
  const { org, project } = Route.useParams();
  return <FunctionsList scope={{ org, project }} search={Route.useSearch()} />;
}
